module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-buttontext-3494c54e27830382fe70b232c31a437a.svg";